import React, { useState, useRef } from 'react'; // build-fix-72a28fb6
import { useAuth } from '../App';
import { useLocation, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Kategorien je Modus
const FEEDBACK_KATEGORIEN = [
  { value: 'verbesserung', label: 'Verbesserung', color: 'var(--brand-info)' },
  { value: 'frage', label: 'Frage', color: 'var(--brand-gold)' },
  { value: 'sonstiges', label: 'Sonstiges', color: 'var(--brand-text-muted)' },
];
// Problem-Modus hat implizit kategorie="bug" - keine Auswahl nötig

export default function FeedbackWidget() {
  const { token, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  // mode: null (beide FABs sichtbar) | 'feedback' | 'problem'
  const [mode, setMode] = useState(null);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ kategorie: 'verbesserung', betreff: '', beschreibung: '' });
  const [files, setFiles] = useState([]);
  const [dragging, setDragging] = useState(false);

  if (!user) return null;
  const canUseDeveloperChat = !(user.disabled_features || []).includes('developer-chat-lite');

  const reset = () => {
    setForm({ kategorie: 'verbesserung', betreff: '', beschreibung: '' });
    setFiles([]);
    setSent(false);
    setSending(false);
  };

  const openMode = (m) => {
    setForm(f => ({
      ...f,
      kategorie: m === 'problem' ? 'bug' : 'verbesserung',
    }));
    setMode(m);
  };

  const handleClose = () => {
    setMode(null);
    setTimeout(reset, 300);
  };

  const handleFiles = (e) => {
    const newFiles = Array.from(e.target.files || []);
    setFiles(prev => [...prev, ...newFiles].slice(0, 5));
  };

  const removeFile = (idx) => {
    setFiles(prev => prev.filter((_, i) => i !== idx));
  };

  const handleSubmit = async () => {
    if (!form.betreff.trim() || !form.beschreibung.trim()) return;
    setSending(true);

    const kategorie = mode === 'problem' ? 'bug' : form.kategorie;

    const fd = new FormData();
    fd.append('kategorie', kategorie);
    fd.append('betreff', form.betreff);
    fd.append('beschreibung', form.beschreibung);
    fd.append('seite', location.pathname);
    files.forEach(f => fd.append('files', f));

    try {
      const res = await fetch(`${API_URL}/feedback/submit`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: fd,
      });
      if (res.ok) {
        setSent(true);
        setSending(false);
      } else {
        setSending(false);
      }
    } catch {
      setSending(false);
    }
  };

  // ─── Zwei FABs, wenn kein Mode aktiv ───
  if (mode === null) {
    return (
      <div style={{
        position: 'fixed',
        bottom: 'calc(20px + env(safe-area-inset-bottom, 0px))',
        right: 'calc(20px + env(safe-area-inset-right, 0px))',
        zIndex: 9998,
        display: 'flex', gap: 10,
      }}>
        {/* Problem melden (rot, links) */}
        <button
          onClick={() => openMode('problem')}
          title="Problem/Bug melden (geht an IT-Support)"
          style={{
            width: 48, height: 48, borderRadius: 12,
            background: 'var(--brand-danger, #c84a3a)', color: '#fff',
            border: '1.5px solid rgba(255,255,255,0.25)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(200,74,58,0.35)',
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.08)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </button>

        {canUseDeveloperChat && (
          <button
            onClick={() => navigate('/developer-chat')}
            title="Developer Chat öffnen"
            style={{
              width: 48, height: 48, borderRadius: 12,
              background: 'var(--brand-info, #1a73e8)', color: '#fff',
              border: '1.5px solid rgba(255,255,255,0.25)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 4px 20px rgba(26,115,232,0.28)',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.08)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              <path d="m10 8-2 2 2 2" />
              <path d="m14 8 2 2-2 2" />
            </svg>
          </button>
        )}

        {/* Feedback (gold, rechts) */}
        <button
          onClick={() => openMode('feedback')}
          title="Feedback geben (Verbesserungen, Fragen)"
          style={{
            width: 48, height: 48, borderRadius: 12,
            background: '#0b1d3a', color: '#C4975A',
            border: '1.5px solid rgba(196,151,90,0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(11,29,58,0.25)',
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.08)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </button>
      </div>
    );
  }

  const inputStyle = {
    width: '100%', padding: '10px 12px', border: '1px solid var(--brand-warm-gray)',
    borderRadius: 6, fontSize: 14, fontFamily: 'var(--font-body)',
    outline: 'none', transition: 'border-color 0.15s',
    minHeight: 44, boxSizing: 'border-box',
  };

  const isProblem = mode === 'problem';
  const headerTitle = isProblem ? 'Problem melden' : 'Feedback';
  const headerSubtitle = isProblem
    ? 'Bug / Fehler - geht direkt an IT-Support'
    : 'Verbesserungen, Fragen, Sonstiges';
  const submitLabel = isProblem ? 'Problem senden' : 'Feedback senden';
  const successMessage = isProblem
    ? 'Dein Problem wurde an den IT-Support weitergeleitet.'
    : 'Dein Feedback wurde gesendet und wird bearbeitet.';
  const headerBg = isProblem ? 'var(--brand-danger, #c84a3a)' : 'var(--brand-navy)';
  const submitBg = isProblem ? 'var(--brand-danger, #c84a3a)' : 'var(--brand-gold)';
  const submitColor = isProblem ? '#fff' : 'var(--brand-navy)';
  const placeholderBeschreibung = isProblem
    ? 'Was ist passiert? Welche Aktion hast du ausgeführt? Welche Fehlermeldung siehst du?'
    : 'Was möchtest du mitteilen? Worum geht es konkret?';

  // ─── Panel ───
  return (
    <div style={{
      position: 'fixed', bottom: 'calc(20px + env(safe-area-inset-bottom, 0px))', right: 'calc(20px + env(safe-area-inset-right, 0px))', zIndex: 9998,
      width: 'min(380px, calc(100vw - 32px))', maxHeight: 'calc(100dvh - 100px)',
      borderRadius: 12, overflow: 'hidden',
      background: '#fff', border: '1px solid var(--brand-warm-gray)',
      boxShadow: '0 8px 40px rgba(11,29,58,0.2)',
      fontFamily: 'var(--font-body)',
      display: 'flex', flexDirection: 'column',
    }}>
      {/* Header */}
      <div style={{
        padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: headerBg, color: '#fff', flexShrink: 0,
      }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600 }}>{headerTitle}</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', marginTop: 1 }}>
            {headerSubtitle}
          </div>
        </div>
        <button onClick={handleClose} style={{
          background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff',
          width: 36, height: 36, borderRadius: 6, cursor: 'pointer', fontSize: 16,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>x</button>
      </div>

      {/* Body */}
      <div style={{ padding: 16, overflowY: 'auto', flex: 1 }}>
        {sent ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>&#10003;</div>
            <div style={{
              fontFamily: 'var(--font-headline)', fontSize: 18, color: 'var(--brand-navy)', marginBottom: 8,
            }}>Danke!</div>
            <div style={{ fontSize: 13, color: 'var(--brand-text-muted)', marginBottom: 20 }}>
              {successMessage}
            </div>
            <button onClick={handleClose} style={{
              padding: '8px 20px', background: 'var(--brand-gold)', color: 'var(--brand-navy)',
              border: 'none', borderRadius: 4, fontSize: 12, fontWeight: 600, cursor: 'pointer',
              fontFamily: 'var(--font-body)',
            }}>Schliessen</button>
          </div>
        ) : (
          <>
            {/* Kategorie - nur im Feedback-Modus */}
            {!isProblem && (
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 6, color: 'var(--brand-navy)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Kategorie
                </label>
                <div style={{ display: 'flex', gap: 6 }}>
                  {FEEDBACK_KATEGORIEN.map(k => (
                    <button
                      key={k.value}
                      onClick={() => setForm(p => ({ ...p, kategorie: k.value }))}
                      style={{
                        flex: 1, padding: '8px 4px', fontSize: 12, fontWeight: 500, minHeight: 36,
                        borderRadius: 4, cursor: 'pointer',
                        fontFamily: 'var(--font-body)',
                        border: form.kategorie === k.value ? `1.5px solid ${k.color}` : '1px solid var(--brand-warm-gray)',
                        background: form.kategorie === k.value ? `${k.color}12` : 'transparent',
                        color: form.kategorie === k.value ? k.color : 'var(--brand-text-muted)',
                        transition: 'all 0.15s',
                      }}
                    >{k.label}</button>
                  ))}
                </div>
              </div>
            )}

            {/* Betreff */}
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 4, color: 'var(--brand-navy)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Betreff *
              </label>
              <input
                value={form.betreff}
                onChange={e => setForm(p => ({ ...p, betreff: e.target.value }))}
                placeholder="Kurze Zusammenfassung..."
                style={inputStyle}
                onFocus={e => e.target.style.borderColor = 'var(--brand-gold)'}
                onBlur={e => e.target.style.borderColor = 'var(--brand-warm-gray)'}
              />
            </div>

            {/* Beschreibung */}
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 4, color: 'var(--brand-navy)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Beschreibung *
              </label>
              <textarea
                value={form.beschreibung}
                onChange={e => setForm(p => ({ ...p, beschreibung: e.target.value }))}
                placeholder={placeholderBeschreibung}
                rows={4}
                style={{ ...inputStyle, resize: 'vertical', minHeight: 80 }}
                onFocus={e => e.target.style.borderColor = 'var(--brand-gold)'}
                onBlur={e => e.target.style.borderColor = 'var(--brand-warm-gray)'}
              />
            </div>

            {/* Datei-Upload mit Drag & Drop */}
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 6, color: 'var(--brand-navy)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {isProblem ? 'Screenshots / Dateien' : 'Dateien anhaengen'}
              </label>
              <input
                ref={fileInputRef}
                type="file"
                multiple
                accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.docx,.doc"
                onChange={handleFiles}
                style={{ display: 'none' }}
              />
              <div
                onClick={() => files.length < 5 && fileInputRef.current?.click()}
                onDragOver={e => { e.preventDefault(); e.stopPropagation(); setDragging(true); }}
                onDragEnter={e => { e.preventDefault(); e.stopPropagation(); setDragging(true); }}
                onDragLeave={e => { e.preventDefault(); e.stopPropagation(); setDragging(false); }}
                onDrop={e => {
                  e.preventDefault(); e.stopPropagation(); setDragging(false);
                  if (files.length >= 5) return;
                  const dropped = Array.from(e.dataTransfer.files || []);
                  setFiles(prev => [...prev, ...dropped].slice(0, 5));
                }}
                style={{
                  width: '100%', padding: files.length > 0 ? '8px 10px' : '16px 10px',
                  border: `1.5px dashed ${dragging ? 'var(--brand-gold)' : 'var(--brand-warm-gray)'}`,
                  borderRadius: 6,
                  background: dragging ? 'var(--brand-gold-10, rgba(196,151,90,0.08))' : 'var(--brand-cream)',
                  cursor: files.length >= 5 ? 'default' : 'pointer',
                  fontSize: 12, color: 'var(--brand-text-muted)',
                  fontFamily: 'var(--font-body)', transition: 'all 0.15s',
                  opacity: files.length >= 5 ? 0.5 : 1,
                  textAlign: 'center',
                }}
              >
                {files.length === 0 ? (
                  <>
                    <div style={{ fontSize: 22, marginBottom: 4, opacity: 0.4 }}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ display: 'inline' }}>
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                      </svg>
                    </div>
                    <span style={{ display: 'block', fontWeight: 500 }}>
                      {dragging ? 'Dateien hier ablegen' : 'Dateien hierher ziehen oder klicken'}
                    </span>
                    <span style={{ fontSize: 10, marginTop: 2, display: 'block' }}>
                      PDF, Bilder, Excel, Word - max. 5 Dateien, je 20 MB
                    </span>
                  </>
                ) : (
                  <span style={{ fontSize: 11 }}>
                    {dragging ? 'Ablegen zum Hinzufuegen' : `+ Weitere Dateien (${files.length}/5)`}
                  </span>
                )}
              </div>

              {/* File List */}
              {files.length > 0 && (
                <div style={{ marginTop: 6, display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {files.map((f, i) => (
                    <div key={i} style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '5px 8px', background: 'var(--brand-cream)', borderRadius: 4,
                      fontSize: 11, color: 'var(--brand-text)',
                    }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 240 }}>
                        {f.name}
                      </span>
                      <span style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                        <span style={{ fontSize: 10, color: 'var(--brand-text-light)' }}>
                          {(f.size / 1024).toFixed(0)} KB
                        </span>
                        <button
                          onClick={e => { e.stopPropagation(); removeFile(i); }}
                          style={{
                            background: 'none', border: 'none', color: 'var(--brand-text-muted)',
                            cursor: 'pointer', fontSize: 14, padding: '0 2px',
                          }}
                        >x</button>
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Seite-Info */}
            <div style={{
              fontSize: 10, color: 'var(--brand-text-light)', marginBottom: 14,
              padding: '6px 8px', background: 'var(--brand-cream)', borderRadius: 4,
            }}>
              Gemeldet von: {user.name} &middot; Seite: {location.pathname}
            </div>

            {/* Submit */}
            <button
              onClick={handleSubmit}
              disabled={sending || !form.betreff.trim() || !form.beschreibung.trim()}
              style={{
                width: '100%', padding: '12px', fontSize: 14, fontWeight: 600, minHeight: 44,
                background: sending ? 'var(--brand-text-muted)' : submitBg,
                color: sending ? '#fff' : submitColor,
                border: 'none', borderRadius: 6, cursor: sending ? 'default' : 'pointer',
                fontFamily: 'var(--font-body)', transition: 'all 0.15s',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                opacity: (!form.betreff.trim() || !form.beschreibung.trim()) ? 0.5 : 1,
              }}
            >
              {sending ? 'Wird gesendet...' : submitLabel}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
